export const enum HotjarEvents {
  PlaylistCreatedFromLibrary = 'playlist_created_from_library',
  PlaylistCreatedFromVideo = 'playlist_created_from_video',
  PlaylistShareableLinkCopied = 'playlist_shareable_link_copied',
  PlaylistLinkCopied = 'playlist_link_copied',
  VideoAddedToPlaylist = 'video_added_to_playlist',
  VideoRemovedFromPlaylist = 'video_removed_from_playlist',

  VideoAddedToCart = 'video_added_to_cart',
  AddToCartFromRecommendedVideos = 'add_to_cart_from_recommended_videos',
  AddToCartFromPlaylistPage = 'add_to_cart_from_playlist_page',
  AddToCartFromVideoPage = 'add_to_cart_from_video_page',
  AddToCartFromVideoCard = 'add_to_cart_from_video_card',
  VideoRemovedFromCart = 'video_removed_from_cart',
  CartOpened = 'cart_opened',
  OrderConfirmed = 'order_placed',

  CopyLinkFromSearchResults = 'copy_link_from_search_results',
  CopyLinkFromVideoPage = 'copy_link_from_video_page',
  FiltersApplied = 'filters_applied',
  VideoPageOpened = 'video_page_opened',
  YourOrdersOpened = 'your_orders_opened',
  MyContentOpened = 'my_content_opened',
  MyTeamOpened = 'my_team_opened',
  MyAccountOpened = 'my_account_opened',
}
